import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ArrowRight } from 'lucide-react';
import { kontaktDaten, sprechzeiten, navigation } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-[#032925] text-[#edd68d] py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Praxis Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-gelb.png" alt="Medicum Diez" className="h-10 w-auto" />
            </div>
            <p className="text-[#edd68d]/70 text-sm leading-relaxed mb-4">
              Ihre Hausärzte für Diez, Limburg und den Rhein-Lahn-Kreis. Persönliche Medizin, modernste Diagnostik und 21 Fachärzte unter einem Dach.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <a href={`tel:${kontaktDaten.telefon.replace(/\s/g, '')}`} className="flex items-center gap-2 text-[#edd68d] hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                {kontaktDaten.telefon}
              </a>
              <a href={`mailto:${kontaktDaten.email}`} className="flex items-center gap-2 text-[#edd68d] hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                {kontaktDaten.email}
              </a>
              <div className="flex items-start gap-2 text-[#edd68d]/70">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>
                  {kontaktDaten.adresse.strasse}<br />
                  {kontaktDaten.adresse.plz} {kontaktDaten.adresse.ort}
                </span>
              </div>
            </div>
          </div>

          {/* Leistungen */}
          <div>
            <h4 className="text-[#edd68d] font-semibold mb-4">Leistungen</h4>
            <ul className="space-y-2">
              {navigation.find(n => n.id === '2')?.children?.slice(0, 8).map((item) => (
                <li key={item.id}>
                  <Link to={item.path} className="text-sm text-[#edd68d]/70 hover:text-[#edd68d] transition-colors flex items-center gap-1">
                    <ArrowRight className="w-3 h-3" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Über uns */}
          <div>
            <h4 className="text-[#edd68d] font-semibold mb-4">Über uns</h4>
            <ul className="space-y-2">
              {navigation.find(n => n.id === '3')?.children?.map((item) => (
                <li key={item.id}>
                  <Link to={item.path} className="text-sm text-[#edd68d]/70 hover:text-[#edd68d] transition-colors flex items-center gap-1">
                    <ArrowRight className="w-3 h-3" />
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/impressum" className="text-sm text-[#edd68d]/70 hover:text-[#edd68d] transition-colors flex items-center gap-1">
                  <ArrowRight className="w-3 h-3" />
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm text-[#edd68d]/70 hover:text-[#edd68d] transition-colors flex items-center gap-1">
                  <ArrowRight className="w-3 h-3" />
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          {/* Sprechzeiten */}
          <div>
            <h4 className="text-[#edd68d] font-semibold mb-4 flex items-center gap-2">
              <Clock className="w-4 h-4" />
              Sprechzeiten
            </h4>
            <ul className="space-y-2 text-sm">
              {sprechzeiten.map((item, index) => (
                <li key={index} className="flex justify-between text-[#edd68d]/70">
                  <span>{item.tag}</span>
                  <span className="text-right">{item.zeit.split(' & ')[0]}</span>
                </li>
              ))}
            </ul>
            <div className="mt-4 pt-4 border-t border-[#edd68d]/20">
              <Link to="/termin" className="inline-flex items-center gap-2 text-[#edd68d] hover:text-white transition-colors text-sm font-medium">
                Termin vereinbaren
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-[#edd68d]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#edd68d]/50">
            <p>© {new Date().getFullYear()} {kontaktDaten.praxisName}. Alle Rechte vorbehalten.</p>
            <div className="flex items-center gap-4">
              <Link to="/impressum" className="hover:text-[#edd68d] transition-colors">Impressum</Link>
              <span>·</span>
              <Link to="/datenschutz" className="hover:text-[#edd68d] transition-colors">Datenschutz</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
